import * as React from "react";
import { Dropdown, Form } from "react-bootstrap";
import "./dropDown.scss";

export class SingleSelectDropDown extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      customClass,
      placeholder,
      selectedValue,
      items,
      onSelect,
      disabled, // optional: undefined or false = enabled
    } = this.props;
    return (
      <Dropdown className={customClass}>
        <Dropdown.Toggle
          disabled={!!disabled} // coerce to boolean, false if undefined
          variant="primary"
          id="dropdown-basic"
          className={`d-flex align-items-center`}
        >
          <div className={`${selectedValue === "" ? "placeholder-txt" : ""}`}>
            {selectedValue === "" ? placeholder : selectedValue}
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {items.map((item, index) => (
            <Dropdown.Item
              className={`${selectedValue == item.value ? "active" : ""}`}
              key={index}
              onClick={() => onSelect(item)}
            >
              {item.value}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}
